import React, { FC, ComponentProps } from 'react';
import { useIntl } from 'dibs-react-intl';
import { LOCALE_DE, LOCALE_FR, LOCALE_IT, LOCALE_ES } from 'dibs-intl/exports/locales';

const ListingUnavailable = React.lazy(() => import('dibs-icons/exports/legacy/ListingUnavailable'));
const ListingUnavailableDe = React.lazy(
    () => import('dibs-icons/exports/legacy/ListingUnavailableDe')
);
const ListingUnavailableFr = React.lazy(
    () => import('dibs-icons/exports/legacy/ListingUnavailableFr')
);
const ListingUnavailableIt = React.lazy(
    () => import('dibs-icons/exports/legacy/ListingUnavailableIt')
);
const ListingUnavailableEs = React.lazy(
    () => import('dibs-icons/exports/legacy/ListingUnavailableEs')
);

type Props = ComponentProps<typeof ListingUnavailable>;

export const LocalizedListingUnavailableIcon: FC<Props> = props => {
    const { locale } = useIntl();

    if (locale === LOCALE_DE) {
        return <ListingUnavailableDe {...props} />;
    }

    if (locale === LOCALE_FR) {
        return <ListingUnavailableFr {...props} />;
    }

    if (locale === LOCALE_IT) {
        return <ListingUnavailableIt {...props} />;
    }

    if (locale === LOCALE_ES) {
        return <ListingUnavailableEs {...props} />;
    }

    return <ListingUnavailable {...props} />;
};
